import template from './add_edit_performance_management.html';
import tr from '../../../lib/default-translator.js';
import * as Utils from '../../../lib/savanna_utils.js';
import * as performance_management_setup_tutorial_config  from '../../../components/tutorial_component/performance_setup_tutorial_config.js';

class EditPerformanceManagementViewModel 
{
	constructor(page) 
	{
		this.page = page;
		let url_hash = window.location.hash.split('#').pop();
		console.log('url hashed ', url_hash);
		let validTabs = ['CycleSetup', 'CompanyObjectives', 'StatusSetup', 'RatingSetup', 'MeasureSetup', 'PeerGroup', 'AccessControl'];
		let defaultTab = validTabs.includes(url_hash) ? url_hash : (localStorage.getItem('last_visited_pm_tab') );
		
		this.selected_tab = ko.observable(defaultTab);

		//cycle setup page
		this.companies = ko.observableArray();
		this.departments = ko.observableArray();
		this.selected_department = ko.observable();
		this.selected_company = ko.observable();
		this.selected_cycle = ko.observable();

		// pagination
		this.current_page_number_pc = ko.observable(1);
		this.current_page_size_pc = ko.observable(10);
		this.page_count_pc = ko.observable(1);
		this.pagination_summary_pc = ko.observable('');
		this.number_of_records_pc = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records_pc = ko.observable(10);

		//company objectives page
		this.edit_all = ko.observable(localStorage.getItem('editing_company_objectives' || false));
		this.company_objectives = ko.observableArray();
		this.new_goal_nr = ko.observable();
		this.new_goal = ko.observable();

		this.max_num = ko.computed(() => {
			return this.company_objectives().length;
		});

		//status/steps setup page
		this.selected_perf_cycle = ko.observable();
		this.steps_loader = ko.observable(false);
		this.details_for_title = ko.observable('');
		this.details_peer_title = ko.observable();
		this.performance_cycles = ko.observableArray();
		this.performance_cycles_for_steps = ko.observableArray();
		this.performance_cycles_select = ko.computed(() => {
			let cycles = this.performance_cycles_for_steps() || [];
			return [{ cycle_name: 'Default', performance_cycle_id: null }].concat(cycles);
		});
		this.performance_cycles_for_steps_replacement = ko.observableArray();
		this.selected_data_lock_rule = ko.observable();
		this.data_lock_rules = ko.observableArray();
		this.cycle_steps = ko.observableArray();
		this.selected_cycle_step = ko.observable();
		this.cycles_template_options = ko.computed(() => {
			let cycles = this.performance_cycles_for_steps_replacement() || [];
			return [{ cycle_name: 'Default', performance_cycle_id: null }].concat(cycles);
		});
		this.sort_field = ko.observable('to_date');
		this.sort_order = ko.observable('DESC');

		this.sorted_steps = ko.computed(() => {
			return this.cycle_steps().sort((a, b) => a.step_sequence - b.step_sequence) || [];
		});

		//Rating method & options page
		this.selected_rating_category = ko.observable(localStorage.getItem('last_visited_category_tab' || 'single-select'));
		this.rating_methods = ko.observableArray();
		this.selected_rating_method = ko.observable();
		this.new_option_input = ko.observable();
		this.new_option_symbol = ko.observable();
		this.limited_options = ko.observable(false);

		//Peer group setup 
		this.selected_peer_group = ko.observable();
		this.details_for_title = ko.observable('');
		this.peer_groups = ko.observableArray();
		this.peer_groups_for_members = ko.observableArray();
		this.unique_peer_groups = ko.observable();
		this.peer_groups_select = ko.computed(() => {
			let groups = this.peer_groups_for_members() || [];
			return groups;
		});
		this.employees = ko.observableArray();
		this.selected_employee = ko.observable();
		this.peer_group_members = ko.observableArray();
		this.selected_peer_group_member = ko.observable();
		this.sorted_members = ko.computed(() => {
			return this.peer_group_members() || [];
		});
		
		//Measures setup
		this.measures = ko.observableArray();
		this.selected_measure = ko.observable();
		this.new_measure = ko.observable();

		this.selected_tab.subscribe((newCategory) => {
			$('.ps-tabs > li').removeClass('active');
			$(`.ps-tabs > li[data-tabname=${newCategory}]`).addClass('active');
		});

		$(`.ps-tabs > li[data-tabname=${this.selected_tab()}]`).addClass('active');

		this.selected_rating_category.subscribe((newCategory) => {
			$('.category-tabs > li').removeClass('active');
			$(`.category-tabs > li[data-tabname=${newCategory}]`).addClass('active');
			this.selected_rating_method('');
			this.page.update_rating_methods();
		});

		$(`.category-tabs > li[data-tabname=${this.selected_rating_category()}]`).addClass('active');

		this.selected_company.subscribe((val) => {
			this.selected_department('');
			this.page.get_all_performance_cycles();
			this.page.get_peer_groups_and_members();
			if (this.selected_company())
				this.page.update_departments();
		});

		this.selected_peer_group.subscribe((val) => {
			console.log('value', val);
			this.page.get_peer_groups_and_members();
			let selected_peer_group = this.unique_peer_groups().find(group => group.peer_group_id === val);
			// Use the name from the found object
			if (selected_peer_group) {
				this.details_peer_title('PEER GROUP: ' + selected_peer_group.peer_group_name);
			}
			

		});

		this.peer_groups.subscribe(function (peerGroups) {
			peerGroups.forEach(function (member) {
				if (member.editing === undefined) {
					member.editing = ko.observable(false);
				}
			});
		});

		this.feature_roles = ko.observableArray();
		this.save_feature = this.save_feature.bind(this);
		this.access_roles = ko.observableArray();

		this.onPeerGroupSelectionChange = function () {
			// This will position the buttons next to the selected option
			setTimeout(() => {
				const selectElement = document.querySelector('.select-container select');
				if (selectElement && this.selected_peer_group()) {
					const selectedOption = selectElement.querySelector('option:checked');
					if (selectedOption) {
						const optionRect = selectedOption.getBoundingClientRect();
						const selectRect = selectElement.getBoundingClientRect();
						const buttonsContainer = document.querySelector('.option-buttons');
						
						if (buttonsContainer) {
							// Position the buttons next to the selected option
							buttonsContainer.style.top = (optionRect.top - selectRect.top + optionRect.height / 2) + 'px';
						}
					}
				}
			}, 10);
		};


		this.selected_department.subscribe((val) => {
			this.page.get_all_performance_cycles();
			this.page.get_peer_groups_and_members();
		});

		this.selected_perf_cycle.subscribe((val) => {
			if (val) {
				if (val.cycle_name !== 'Default' && this.selected_perf_cycle()) {
					this.details_for_title('STAGES FOR: ' + val.cycle_name);
					this.page.update_status_steps();
				}
				else if (val.cycle_name === 'Default') {
					this.details_for_title('DEFAULT STAGE');
					this.page.update_status_steps();
				}
			}
		});

		this.selected_number_of_records_pc.subscribe((val) => {
			localStorage.setItem('selected_number_of_records_perform_cycles', this.selected_number_of_records_pc());
			this.current_page_size_pc(val);
			this.page.updateData();
		});
		this.tutorial_config = ko.observable(performance_management_setup_tutorial_config);
	}

	sort_column(column) {
		if (column && column.trim() !== '') {
			if (this.sort_field() === column)
				this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
			else {
				this.sort_field(column);
				this.sort_order('ASC');
			}
			this.page.updateData();
		}
	}

	btn_show_help() {
		Grape.dialog.open('EditPerformanceManagementHelp', {});
	}

	btn_show_cycle_setup_help() {
		Grape.dialog.open('PerformanceCyclesHelp', {});
	}

	btn_show_company_goals_help() {
		Grape.dialog.open('CompanyGoalsHelp', {});
	}

	btn_show_cycle_stages_help() {
		Grape.dialog.open('CycleStageHelp', {});
	}

	btn_show_rating_methods_help() {
		Grape.dialog.open('RatingMethodsHelp', {});
	}

	btn_show_obj_measures_help() {
		Grape.dialog.open('ObjectiveMeasuresHelp', {});
	}

	switch_tabs(v, e) {
		let tabname = e.currentTarget.getAttribute('data-tabname');
		localStorage.setItem('last_visited_pm_tab', tabname);
		this.selected_tab(tabname);
		$(`.category-tabs > li[data-tabname=${this.selected_rating_category()}]`).addClass('active');
	}

	//===================================================================================================
	// CYCLE SETUP PAGE
	page_click_pc(page_number) {
		this.current_page_number_pc(page_number);
		this.page.updateData();
	}

	field_select_cycle_click(data) {
		this.selected_cycle(data);
	}

	async btn_add_cycle_click(data) {
		await Grape.dialog.open('CreateCycle', { data: data });
		this.page.updateData();
		// to set the selected for stages/steps to the one just created
		await this.page.get_all_performance_cycles();
		let length = this.performance_cycles_select().length - 1;
		this.selected_perf_cycle(this.performance_cycles_select()[length]);
	}

	async btn_edit_cycle(data) {
		await Grape.dialog.open('CreateCycle', { data: data, edit: true });
		this.page.updateData();
		// to set the selected for stages/steps to the one just edited
		await this.page.get_all_performance_cycles();
		let length = this.performance_cycles_select().length - 1;
		this.selected_perf_cycle(this.performance_cycles_select()[length]);
	}

	async btn_remove_cycle(data) {
		let response = await Grape.alerts.confirm({ type: 'warning', title: 'Confirm', message: `Are you sure you want to remove ${data.cycle_name}?` });
		if (response) {
			let res = await Grape.fetches.postJSON('/performance_management/cycles/remove', { cycle_id: data.performance_cycle_id });
			if (res.status == 'OK') {
				Grape.alerts.alert({ type: 'success', message: 'Performance Cycle removed successfully!' });
				this.selected_cycle('');
				this.current_page_number_pc(1);
				this.page.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', title: 'Error', message: 'An error occurred while removing the Perfomance Cycle...' });
		}
	}

	//===================================================================================================
	// COMPANY OBJECTIVES
	btn_enable_edit_all() {
		this.edit_all(!this.edit_all());
		localStorage.setItem('editing_company_objectives', this.edit_all());
	}

	async btn_edit_mission(data) {
		if (!data.edit())
			data.edit(!data.edit());
		else {
			try {
				let res = await Grape.fetches.postJSON('/performance_management/company_objectives/edit', {
					mission: data.mission,
					number: data.objective_number,
					company_objective_id: data.company_objective_id
				});

				if (res.status === 'ERROR')
					Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the mission & vision.' });
				else if (res.status === 'OK') {
					Grape.alerts.alert({ type: 'success', message: 'Successfully saved the mission & vision.' });
					data.edit(!data.edit());
					this.page.update_company_objectives();
				}
				else
					Grape.alerts.apiError(res);

			} catch (errror) {
				Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the mission & vision.' });
				console.error(error);
			}
		}
	}

	async btn_edit_goal(data) {
		if (!data.edit())
			data.edit(!data.edit());
		else {
			try {
				let goal_nr = `${Math.floor(data.goal_nr)}.${data.goal_sub_number()}`;
				let res = await Grape.fetches.postJSON('/performance_management/company_objectives/edit_goal', {
					goal: data.goal,
					company_objective_goal_id: data.goal_id,
					goal_nr: goal_nr
				});

				if (res.status === 'ERROR')
					Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the goal.' });
				else if (res.status === 'OK') {
					Grape.alerts.alert({ type: 'success', message: 'Successfully saved the goal.' });
					data.edit(!data.edit());
					this.page.update_company_objectives();
				}
				else
					Grape.alerts.apiError(res);

			} catch (errror) {
				Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the goal.' });
				console.error(error);
			}
		}
	}

	async btn_edit_subgoal(data) {
		if (!data.edit())
			data.edit(!data.edit());
		else {
			try {
				let subgoal_nr = `${data.subgoal_prefix()}.${data.subgoal_sub_number()}`;
				let res = await Grape.fetches.postJSON('/performance_management/company_objectives/edit_subgoal', {
					subgoal: data.subgoal,
					company_obj_subgoal_id: data.subgoal_id,
					subgoal_nr: subgoal_nr,
					action: 'update'
				});

				if (res.status === 'ERROR')
					Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the subgoal.' });
				else if (res.status === 'OK') {
					Grape.alerts.alert({ type: 'success', message: 'Successfully saved the subgoal.' });
					data.edit(!data.edit());
					this.page.update_company_objectives();
				}
				else
					Grape.alerts.apiError(res);

			} catch (errror) {
				Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the subgoal.' });
				console.error(error);
			}
		}
	}

	btn_add_subgoal(data) {
		data.adding_goal(!data.adding_goal());
	}

	btn_add_goal(data) {
		data.adding_goal(!data.adding_goal());
	}

	async btn_save_new_goal(data) {
		if (!this.new_goal()) {
			Grape.alerts.alert({ type: 'warning', message: 'Goal cannot be empty' });
			return;
		}
		else {
			try {
				//let goal_nr = `${data.goal_nr}.${this.new_goal_nr()}`;
				let res = await Grape.fetches.postJSON('/performance_management/company_objectives/edit_goal', {
					goal: this.new_goal(),
					company_objective_id: data.company_objective_id
				});

				if (res.status === 'ERROR')
					Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the subgoal.' });
				else if (res.status === 'OK') {
					Grape.alerts.alert({ type: 'success', message: 'Successfully saved the subgoal.' });
					this.page.update_company_objectives();
					this.new_goal(null);
					this.new_goal_nr(null);
				}
				else
					Grape.alerts.apiError(res);

			} catch (errror) {
				Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the subgoal.' });
				console.error(error);
			}
		}
	}

	async btn_save_new_subgoal(data) {
		if (!this.new_goal()) {
			Grape.alerts.alert({ type: 'warning', message: 'Subgoal cannot be empty' });
			return;
		}
		else if (!this.new_goal_nr())
			this.new_goal_nr(null);
		
		try {
			let subgoal_nr = `${data.goal_nr}.${this.new_goal_nr()}`;
			let res = await Grape.fetches.postJSON('/performance_management/company_objectives/edit_subgoal', {
				subgoal: this.new_goal(),
				subgoal_nr: subgoal_nr,
				company_objective_goal_id: data.goal_id,
				action: 'insert'
			});

			if (res.status === 'ERROR')
				Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the subgoal.' });
			else if (res.status === 'OK') {
				Grape.alerts.alert({ type: 'success', message: 'Successfully saved the subgoal.' });
				this.page.update_company_objectives();
				this.new_goal(null);
				this.new_goal_nr(null);
			}
			else
				Grape.alerts.apiError(res);

		} catch (error) {
			Grape.alerts.alert({ type: 'error', message: 'An error occurred when saving the subgoal.' });
			console.error(error);
		}
	}

	btn_cancel_save(data) {
		data.adding_goal(!data.adding_goal());
		this.new_goal(null);
		this.new_goal_nr(null);
	}

	async btn_remove_mission(data) {
		if (data.edit())
			data.edit(!data.edit())
		else if (!data.edit()) {
			let response = await Grape.alerts.confirm({ type: 'confirm', title: 'Confirm', message: 'Are you sure you want to remove the entire company objective?' });
			if (response) {
				try {
					let res = await Grape.fetches.postJSON('/performance_management/company_objectives/edit', {
						company_objective_id: data.company_objective_id,
						action: 'delete'
					});
					if (res.status === 'ERROR')
						Grape.alerts.alert({ type: 'error', message: 'An error occurred when removing the company objective.' });
					else if (res.status === 'OK') {
						Grape.alerts.alert({ type: 'success', message: 'Successfully removed the company objective.' });
						this.page.update_company_objectives();
						this.new_goal(null);
						this.new_goal_nr(null);
					}
					else
						Grape.alerts.apiError(res);
	
				} catch (errror) {
					Grape.alerts.alert({ type: 'error', message: 'An error occurred when removing the company objective.' });
					console.error(error);
				}
			}
		}
	}

	async btn_remove_goal(data) {
		if (data.edit())
			data.edit(!data.edit())
		else if (!data.edit()) {
			let response = await Grape.alerts.confirm({ type: 'confirm', title: 'Confirm', message: 'Are you sure you want to remove this goal?' });
			if (response) {
				try {
					let res = await Grape.fetches.postJSON('/performance_management/company_objectives/edit_goal', {
						company_objective_goal_id: data.goal_id,
						action: 'delete'
					});
					if (res.status === 'ERROR')
						Grape.alerts.alert({ type: 'error', message: 'An error occurred when removing the goal.' });
					else if (res.status === 'OK') {
						Grape.alerts.alert({ type: 'success', message: 'Successfully removed the goal.' });
						this.page.update_company_objectives();
						this.new_goal(null);
						this.new_goal_nr(null);
					}
					else
						Grape.alerts.apiError(res);
	
				} catch (errror) {
					Grape.alerts.alert({ type: 'error', message: 'An error occurred when removing the goal.' });
					console.error(error);
				}
			}
		}
	}

	async btn_remove_subgoal(data) {
		if (data.edit())
			data.edit(!data.edit())
		else if (!data.edit()) {
			let response = await Grape.alerts.confirm({ type: 'confirm', title: 'Confirm', message: 'Are you sure you want to remove this subgoal?' });
			if (response) {
				try {
					let res = await Grape.fetches.postJSON('/performance_management/company_objectives/edit_subgoal', {
						company_obj_subgoal_id: data.subgoal_id,
						action: 'delete'
					});
					if (res.status === 'ERROR')
						Grape.alerts.alert({ type: 'error', message: 'An error occurred when removing the subgoal.' });
					else if (res.status === 'OK') {
						Grape.alerts.alert({ type: 'success', message: 'Successfully removed the subgoal.' });
						this.page.update_company_objectives();
						this.new_goal(null);
						this.new_goal_nr(null);
					}
					else
						Grape.alerts.apiError(res);
	
				} catch (errror) {
					Grape.alerts.alert({ type: 'error', message: 'An error occurred when removing the subgoal.' });
					console.error(error);
				}
			}
		}
	}

	async btn_add_company_obj_click() {
		await Grape.dialog.open('AddCompanyObj', { data: this.company_objectives() });
		this.page.update_company_objectives();
	}

	//===================================================================================================
	// STEPS/STAGES SETUP

	async btn_replace_steps(data) {
		let response;
		if (data.cycle_name != 'Default')
			response = await Grape.alerts.confirm({ type: 'confirm', title: 'Confirm', message: `Are you sure you want to replace all these steps with the stages from ${data.cycle_name}?` });
		else
			response = await Grape.alerts.confirm({ type: 'confirm', title: 'Confirm', message: `Are you sure you want to replace all these steps with the default stages?` });

		if (response) {
			let res = await Grape.fetches.postJSON('/performance_management/cycle_step/edit', {
				performance_cycle_id: this.selected_perf_cycle().performance_cycle_id,
				predefined: true,
				template: data.performance_cycle_id,
				action: 'edit'
			});
			if (res.status == 'ERROR') {
				console.error(error);
				Grape.alerts.apiError(res);
			}
			else if (res.status == 'OK') {
				Grape.alerts.alert({ type: 'success', message: 'Successfully updated stages!' });
				this.page.update_status_steps();
			}
			else {
				console.error(error);
				Grape.alerts.alert({ type: 'error', title: 'error', message: 'Error occurred while replacing stages' });
			}
		}
	}

	async move_order_up(step) {
		let index = this.cycle_steps.indexOf(step);
		if (index > 0) {
			let previous_step = this.cycle_steps()[index - 1];
			let current_seq = step.step_sequence;
			step.step_sequence = previous_step.step_sequence;
			previous_step.step_sequence = current_seq;
			await this.page.update_step_sequence(step);
			await this.page.update_step_sequence(previous_step);
			this.cycle_steps.sort((a, b) => a.step_sequence - b.step_sequence);
		}
	}

	async move_order_down(step) {
		let index = this.cycle_steps.indexOf(step);
		if (index < this.cycle_steps().length - 1) {
			let next_step = this.cycle_steps()[index + 1];
			let current_seq = step.step_sequence;
			step.step_sequence = next_step.step_sequence;
			next_step.step_sequence = current_seq;
			await this.page.update_step_sequence(step);
			await this.page.update_step_sequence(next_step);
			this.cycle_steps.sort((a, b) => a.step_sequence - b.step_sequence);
		}
	}

	btn_edit_step(data) {
		data.editing(!data.editing());
	}

	async btn_save_step(data) {
		let rules = data.rules().map(x => x.step_rule_id);

		if (!data.name) {
			Grape.alerts.alert({ type: 'warning', message: 'Stage name cannot be empty!' });
			return;
		}

		let options;
		if (this.selected_perf_cycle().performance_cycle_id) {
			options = {
				cycle_step_id: data.cycle_step_id,
				name: data.name,
				performance_cycle_id: data.performance_cycle_id,
				rules: JSON.stringify(rules)
			}
		}
		else {
			options = {
				default_cycle_step_id: data.default_cycle_step_id,
				name: data.name,
				performance_cycle_id: data.performance_cycle_id,
				rules: JSON.stringify(rules),
				action: 'edit'
			}
		}

		let response = await Grape.alerts.confirm({ type: 'warning', message: 'Are you sure you want to save changes to this step?' });
		if (response) {
			let res = await Grape.fetches.postJSON('/performance_management/cycle_step/edit', options);

			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				this.page.update_status_steps();
		}
	}

	async btn_remove_step(data) {
		let response = await Grape.alerts.confirm({ type: 'warning', message: 'Are you sure you want to remove this step?' });
		if (response) {
			if (this.selected_perf_cycle().performance_cycle_id) {
				let res = await Grape.fetches.postJSON('/performance_management/cycle_step/remove', { cycle_step_id: data.cycle_step_id });

				if (res.status !== 'OK')
					Grape.alerts.apiError(res);
			}
			else {
				let res = await Grape.fetches.postJSON('/performance_management/cycle_step/edit', {
					default_cycle_step_id: data.default_cycle_step_id,
					action: 'delete'
				});

				if (res.status !== 'OK')
					Grape.alerts.apiError(res);
			}

			this.page.update_status_steps();
		}
	}

	async btn_add_new_stage() {
		let total_steps_length = this.sorted_steps().length + 1;
		await Grape.dialog.open('AddCycleStep', { step_sequence: total_steps_length, rules: this.data_lock_rules(), cycle: this.selected_perf_cycle() });
		this.page.update_status_steps();
	}

	btn_view_default_steps() {
		let default_ = this.performance_cycles_select().find(cycle => cycle.cycle_name === 'Default');

		if (default_)
			this.selected_perf_cycle(default_);
	}

	//===================================================================================================
	// RATING METHODS PAGE
	switch_rating_category(v, e) {
		let tabname = e.currentTarget.getAttribute('data-tabname');
		localStorage.setItem('last_visited_category_tab', tabname);
		this.selected_rating_category(tabname);
	}

	btn_edit_rating_method(data) {
		data.editing(!data.editing());
	}

	view_linked_objectives(data) {
		data.view_objectives(!data.view_objectives());
	}

	async btn_add_new_rating_method() {
		await Grape.dialog.open('AddRatingMethod', {});
		this.page.update_rating_methods();
	}

	async btn_remove_rating_method(data) {
		let response = await Grape.alerts.confirm({ type: 'warning', message: `Are you sure you want to delete rating method: ${data.rating_method_name}?` });
		if (response) {
			let res = await Grape.fetches.postJSON('/performance_management/rating_method/remove', { rating_system_id: data.rating_system_id });

			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else {
				this.page.update_rating_methods();
				this.selected_rating_method('');
			}
		}
	}

	async btn_save_rating_method(data) {
		let res = await Grape.fetches.postJSON('/performance_management/rating_method/edit', {
			rating_system_id: data.rating_system_id,
			description: data.rating_method_description,
			name: data.rating_method_name,
			type: data.rating_method_type,
			active: data.active
		});

		if (res.status != 'ERROR')
			this.page.update_rating_methods();
		else
			Grape.alerts.apiError(res);

		data.editing(!data.editing());
	}

	field_select_rating_click(data) {
		this.selected_rating_method(data);

		if (data.rating_method_type === 'input' && data.options)
			this.limited_options(true);
		else if (data.rating_method_type === 'number' && data.options)
			this.limited_options(true);
		else if (data.rating_method_type === 'range' && data.options)
			this.limited_options(true);
		else
			this.limited_options(false);
	}

	async btn_add_rating_option() {
		if (!this.new_option_input())
			this.new_option_input(' ');

		let res = await Grape.fetches.postJSON('/performance_management/rating_option/edit', {
			rating_system_id: this.selected_rating_method().rating_system_id,
			name: this.new_option_input(),
			symbol: this.new_option_symbol()
		});

		if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else {
			this.new_option_input('');
			this.new_option_symbol('');
			await this.page.update_rating_methods();
		}
	}

	async btn_remove_rating_option(data) {
		let res = await Grape.fetches.postJSON('/performance_management/rating_option/remove', {
			rating_option_id: data.option_id
		});

		if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else {
			await this.page.update_rating_methods();
			this.limited_options(false);
		}
	}

	//===================================================================================================
	// MEASURE SETUP PAGE
	async btn_add_new_measure() {
		if (!this.new_measure()) {
			Grape.alerts.alert({ type: 'warning', message: 'Measure cannot be empty!' });
			return;
		}
		else {
			let res = await Grape.fetches.postJSON('/performance_management/measure/edit', {
				measure: this.new_measure()
			});

			if (res.status == 'OK') {
				Grape.alerts.alert({ type: 'success', message: 'Successsfully added new measure' });
				this.page.update_measures();
				this.new_measure(null);
			}
			else if (res.status == 'ERROR') {
				Grape.alerts.apiError(res);
				console.error(res.message);
			}
			else
				Grape.alerts.alert({ type: 'error', message: 'An error occurred while saving new measure' });
		}
	}

	async btn_save_measure(data) {
		if (!this.selected_measure()) {
			Grape.alerts.alert({ type: 'warning', message: 'Please choose a measure from the list' });
			return;
		}
		else {
			let res = await Grape.fetches.postJSON('/performance_management/measure/edit', {
				measure: this.selected_measure().measure,
				measure_id: this.selected_measure().measure_id
			});

			if (res.status == 'OK') {
				Grape.alerts.alert({ type: 'success', message: 'Successfully saved measure' });
				this.page.update_measures();
			}
			else if (res.status == 'ERROR') {
				Grape.alerts.apiError(res);
				console.error(res.message);
			}
			else
				Grape.alerts.alert({ type: 'error', message: 'An error occurred while editing measure' });
		}
	}

	async btn_remove_measure() {
		let response = await Grape.alerts.confirm({ type: 'warning', message: 'Are you sure you want to remove this measure?' });
		if (response) {
			if (this.selected_measure().measure_id) {
				let res = await Grape.fetches.postJSON('/performance_management/measure/edit', {
					measure_id: this.selected_measure().measure_id,
					action: 'delete'
				});
				if (res.status !== 'OK')
					Grape.alerts.apiError(res);
			}

			this.page.update_measures();
		}
	}

	async btn_add_peer_group() 
	{
		await Grape.dialog.open('AddPeerGroup', {});
		await this.page.get_peer_groups_and_members();
		await this.page.updateData();

	}

	async btn_remove_group(data) 
	{
		console.log('Data to remove peer group', data)
		let response = await Grape.alerts.confirm({ type: 'warning', message: `Are you sure you want to delete peer group : ${data.peer_group_name}?` });
		if (response) {
			let res = await Grape.fetches.postJSON('/performance_management/peer/remove_peer_group', { peer_group_id: data.peer_group_id });

			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
			{
				this.page.updateData();
				this.selected_peer_group('')
			}
		}
		this.page.updateData();
		this.selected_peer_group();
	}

	async btn_edit_peer_group(data)
	{
		try {
			// Fetch all peer group members directly from the view
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_peer_group',
				schema: 'perfm_manage',
				fields: [
					'peer_member_id',
					'peer_group_id',
					'peer_group_name',
					'description',
					'employee_id',
					'full_name',
					'department_id',
					'company_id'
				],
				filter: [{
					field: 'peer_group_id',
					operand: '=',
					value: data.peer_group_id
				}]
			});

			console.log('Debug', res);
	
			if (res.status === 'ERROR' || !res.records || res.records.length === 0) {
				Grape.alerts.alert({ type: 'error', message: 'Failed to load peer group details.' });
				return;
			}
	
			// Format the data for the dialog
			// Extract the first record for the peer group details
			const peerGroupRecord = res.records[0];
			
			// Create the main peer group data object as the first element
			const complete_data = [{
				peer_group_id: peerGroupRecord.peer_group_id,
				peer_group_name: peerGroupRecord.peer_group_name,
				description: peerGroupRecord.description,
				department_id: peerGroupRecord.department_id,
				company_id: peerGroupRecord.company_id
			}];
	
			// Add each member record as additional elements in the array
			res.records.forEach(memberRecord => {
				// Split the full name to extract firstname and surname if needed
				let nameParts = memberRecord.full_name ? memberRecord.full_name.trim().split(' ') : [];
				let firstname = nameParts.length > 0 ? nameParts[0] : "";
				let surname = nameParts.length > 1 ? nameParts.slice(1).join(' ') : "";
	
				complete_data.push({
					peer_group_member_id: memberRecord.peer_member_id,
					employee_id: memberRecord.employee_id,
					full_name: memberRecord.full_name,
					firstname: firstname,
					surname: surname
				});
			});
	
			console.log('Opening dialog with data:', complete_data);
	
			// Open the dialog with the complete data
			Grape.dialog.open('AddPeerGroup', { data: complete_data });
	
			// Update data and refresh peer groups list after dialog closes
			this.page.updateData();
			await this.page.get_peer_groups_and_members();
		} catch (error) {
			console.error('Error loading peer group data:', error);
			Grape.alerts.alert({
				type: 'error',
				message: 'An error occurred while loading peer group data: ' + (error.message || error)
			});
		}
	}

	async btn_add_peer_member() 
	{
		// Save the current selection
		let current_selected_group = this.selected_peer_group();
		
		// Open the dialog
		await Grape.dialog.open('AddPeerGroup', {
			data: this.peer_groups(),
			selected_peer_group_id: current_selected_group
		});

		// Refresh data
		await this.page.get_peer_groups_and_members();

		// Restore the selection if it still exists
		if (current_selected_group) {
			const stillExists = this.unique_peer_groups().some(g => g.peer_group_id === current_selected_group);
			if (stillExists) {
				this.selected_peer_group(current_selected_group);
			}
		}
	}

	//==================================================================================================
	edit_feature(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().next();

		view_row.hide();
		edit_row.show();
	}

	cancel_edit(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent().parent();
		view_row.show();
		edit_row.hide();
	}

	async save_feature(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		let data = ko.mapping.toJS(v);

		let res = await Grape.fetches.postJSON('/admin/save_feature_roles', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully Saved Feature.'), title: tr('Success')});
			this.page.updateData();
			edit_row.hide();
			//location.reload();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			this.page.updateData();
		}
		else if (res.error)
		{
			Grape.alerts.alert({type: 'error', message: res.error, title: tr('Error')});
			this.page.updateData();
		} 
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});

		view_row.show();
		edit_row.hide();
	}
}

class EditPerformanceManagement
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EditPerformanceManagementViewModel(this);
		let selected_number_of_records_pc = localStorage.getItem('selected_number_of_records_perform_cycles');

		if (selected_number_of_records_pc)
		{
			this.viewModel.selected_number_of_records_pc(selected_number_of_records_pc);
			this.viewModel.current_page_size_pc(selected_number_of_records_pc);
		}
	}

	async init()
	{
		document.title = tr('Setup Performance Management');
		window.current_page_title(tr('Add/Edit Performance Management'));

		let url_hash = window.location.hash.split('#').pop();
		let validTabs = ['CycleSetup', 'CompanyObjectives', 'StatusSetup', 'RatingSetup', 'MeasureSetup', 'PeerGroup'];
		if (validTabs.includes(url_hash)) {
			this.viewModel.selected_tab(url_hash);
    
			// Remove only the tab-specific hash part, keep the main navigation hash
			const currentHash = window.location.hash;
			const mainHash = '#admin/add_edit_performance_management';
    
			if (currentHash.includes(mainHash + '#')) {
				// Only replace if we have the double hash pattern
				if (window.history.replaceState) {
					window.history.replaceState(null, null, window.location.pathname + window.location.search + mainHash);
				}
			}
		}


		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'company',
				schema: 'public'
			});

			if (res.status != 'ERROR')
				this.viewModel.companies(res.records);
		} catch (error) {
			console.error(error);
		}

		Utils.refresh_data_visible_roles();
		this.get_data_lock_rules();
		this.update_rating_methods();
		this.get_all_performance_cycles();
		this.get_peer_groups_and_members();
		this.update_company_objectives();
		this.update_measures();
	}

	async updateData()
	{
		this.get_peer_groups_and_members();
		let options = {
			table: 'v_performance_cycles',
			schema: 'perfm_manage',
			limit: this.viewModel.current_page_size_pc(),
			sortfield: this.viewModel.sort_field(),
			sortorder: this.viewModel.sort_order(),
			offset: 0
		}
		//LOGIC: Pagination
		if (this.viewModel.current_page_number_pc() && this.viewModel.current_page_size_pc())
		{
			options.limit = this.viewModel.current_page_size_pc();
			options.offset = (this.viewModel.current_page_number_pc() - 1) * this.viewModel.current_page_size_pc();
		}

		try {
			let res = await Grape.fetches.getJSON('/api/record', options)
			if (res.status != 'ERROR')
			{
				this.viewModel.performance_cycles(res.records);
				this.viewModel.page_count_pc(Math.ceil(res.total / res.limit));
				this.viewModel.pagination_summary_pc(`Showing ${options.offset} - ${this.viewModel.current_page_number_pc() * this.viewModel.current_page_size_pc()} of ${res.total} row(s)`);
			}
		} catch (error) {
			console.error(error);
		}
		try {
			let options = {
				table: 'v_feature_roles',
				schema: 'savanna',
				limit: 1000000,
				filter: [{
					field: 'category',
					op: '=',
					value: 'PerformanceManagement'
				}]
			}
			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status == 'OK')
			{
				if (res.records != null || res.records != undefined)
					this.viewModel.feature_roles(res.records);
			}
		} catch (error)
		{
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Could not load feature roles.'});
			console.error(error);
		}

		try {
			let options = {
				table: 'access_role',
				schema: 'grape',
				limit: 1000000,
				sortfield: 'role_name',
				sortorder: 'ASC',
				filter: [{
						value: ['guest','admin','manager','employee','accountant','general_manager','all','developer','director', 'peer'],
						operand: 'IN',
						field: 'role_name'
					}]
			
			};

			let res = await Grape.fetches.getJSON('/api/record', options);
			

			if (res.status == 'OK')
			{
				if (res.records != null || res.records != undefined)
					this.viewModel.access_roles(res.records);
			}
		
		} catch (error)
		{
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Could not load access roles.')});
			console.error(error);
		}

		Utils.refresh_data_visible_roles();
	}

	async get_peer_groups_and_members() {
		// First, get all unique peer groups with company/department filters
		let uniqueOptions = {
			table: 'v_peer_group',
			schema: 'perfm_manage',
			limit: 1000,
			filter: [],
			filter_join: 'AND'
		};
		// Apply company filter
		if (this.viewModel.selected_company()) {
			uniqueOptions.filter.push({
				field: 'company_id',
				operand: '=',
				value: this.viewModel.selected_company()
			});
		}
		// Apply department filter
		if (this.viewModel.selected_department()) {
			uniqueOptions.filter.push({
				field: 'department_id',
				operand: '=',
				value: this.viewModel.selected_department().department_id
			});
		}
		let uniqueRes = await Grape.fetches.getJSON('api/record', uniqueOptions);

		// Build unique peer groups list
		if (uniqueRes && uniqueRes.records) {
			let unique_peer_groups = [];
			let seen_ids = new Set();
			uniqueRes.records.forEach(record => {
				if (!seen_ids.has(record.peer_group_id)) {
					seen_ids.add(record.peer_group_id);
					unique_peer_groups.push({
						peer_group_id: record.peer_group_id,
						peer_group_name: record.peer_group_name
					});
				}
			});

			this.viewModel.unique_peer_groups(unique_peer_groups);

			// Reset selection if the selected peer group is no longer in the filtered list
			if (this.viewModel.selected_peer_group()) {
				let stillExists = unique_peer_groups.some(g => g.peer_group_id === this.viewModel.selected_peer_group());
				if (!stillExists) {
					this.viewModel.selected_peer_group(null);
				}
			}
		}
		// Now get members for the selected peer group
		let memberOptions = {
			table: 'v_peer_group',
			schema: 'perfm_manage',
			limit: 1000,
			filter: [],
			filter_join: 'AND'
		};

		// Check if a peer group is selected
		if (this.viewModel.selected_peer_group()) {
			memberOptions.filter.push({
				field: 'peer_group_id',
				operand: '=',
				value: this.viewModel.selected_peer_group()
			});
			let memberRes = await Grape.fetches.getJSON('api/record', memberOptions);

			if (memberRes && memberRes.records) {
				memberRes.records.forEach(record => {
					record.editing = ko.observable(false);
				});

				this.viewModel.peer_groups(memberRes.records);
			}
		} else {
			// Clear peer groups if nothing is selected
			this.viewModel.peer_groups([]);
		}
	}

	async get_all_performance_cycles()
	{
		let options = {
			table: 'v_performance_cycles',
			schema: 'perfm_manage',
			filter_join: 'AND',
			filter:[]
		}

		try {
			let res = await Grape.fetches.getJSON('/api/record', options);

			if (res.status != 'ERROR')
				this.viewModel.performance_cycles_for_steps_replacement(res.records);
		} catch (error) {
			console.error(error);
		}

		if (this.viewModel.selected_company())
			options.filter.push({
				field: 'company_id',
				operand: '=',
				value: this.viewModel.selected_company()
			});
		
		if (this.viewModel.selected_department())
		{
			options.filter.push({
				field: 'department_id',
				operand: '=',
				value: this.viewModel.selected_department().department_id
			})
		}

		try {
			let res = await Grape.fetches.getJSON('/api/record', options)
			if (res.status != 'ERROR')
				this.viewModel.performance_cycles_for_steps(res.records);
		} catch (error) {
			console.error(error);
		}

		Utils.refresh_data_visible_roles();
	}

	async update_departments()
	{
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_department_company',
				schema: 'savanna',
				filter: [{
					field: 'company_id',
					operand: '=',
					value: this.viewModel.selected_company()
				}]
			})
			if (res.status != 'ERROR')
				this.viewModel.departments(res.records);
		} catch (error) {
			console.error(error);
		}

		Utils.refresh_data_visible_roles();
	}

	async get_data_lock_rules()
	{
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'step_rule',
				schema: 'perfm_manage'
			})
			if (res.status != 'ERROR')
				this.viewModel.data_lock_rules(res.records);
		} catch (error) {
			console.error(error);
		}

		Utils.refresh_data_visible_roles();
	}

	async update_status_steps()
	{
		this.viewModel.steps_loader(true);

		if (this.viewModel.selected_perf_cycle().cycle_name == 'Default')
		{
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_default_cycle_steps',
				schema: 'perfm_manage'
			});

			if (res.status !== 'ERROR')
			{
				// Add edit properties and tules as ko array
				let steps = res.records.map((x) => ({
					...x,
					rules: ko.observableArray( x.rules || []),
					editing: ko.observable(false)
				}));
				this.viewModel.cycle_steps(steps);
			}
			else
				Grape.alerts.alert({type: 'error', message: 'An error occurred while loading the default steps'});
		}
		else
		{
			try {
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'v_cycle_stages',
					schema: 'perfm_manage',
					filter: [{
						field: 'performance_cycle_id',
						operand: '=',
						value: this.viewModel.selected_perf_cycle().performance_cycle_id
					}]
				})

				if (res.status != 'ERROR')
				{
					// Add edit properties and rules as ko array
					let steps = res.records.map((x) => ({
						...x,
						rules: ko.observableArray( x.rules || []),
						editing: ko.observable(false)
					}));
					this.viewModel.cycle_steps(steps);
				}
			} catch (error) {
				console.error(error);
			}
		}
		this.viewModel.steps_loader(false);
		Utils.refresh_data_visible_roles();
	}

	async update_step_sequence(step)
	{
		let options;
		if (step.default_cycle_step_id)
		{
			options = {
				default_cycle_step_id: step.default_cycle_step_id,
				step_sequence: step.step_sequence,
				action: 'edit'
			}
		}
		else if (step.performance_cycle_id)
		{
			options = {
				cycle_step_id: step.cycle_step_id,
				step_sequence: step.step_sequence
			}
		}
		try {
			let res = await Grape.fetches.postJSON('/performance_management/cycle_step/edit', options);
			if (res.status != 'ERROR')
				this.update_status_steps();
			else
				Grape.alerts.apiError(res);
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type:'error', message: 'Error occurred while chaging sequence'});
		}

		Utils.refresh_data_visible_roles();
	}

	async update_rating_methods()
	{
		try {
			let options = {
				table: 'v_rating_methods',
				schema: 'perfm_manage',
				filter_join: 'OR',
				filter: [{
					field: 'rating_method_type',
					operand: '=',
					value: this.viewModel.selected_rating_category()
				}]
			}

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status != 'ERROR')
			{
				// Add total linked objective plans
				let methods = res.records.map((x) => ({
					...x, 
					objective_plans: x.linked_objective_plans,
					total_linked_objective_plans: x.linked_objective_plans ? x.linked_objective_plans.length : 0,
					view_objectives: ko.observable(false),
					editing: ko.observable(false)
				}));

				this.viewModel.rating_methods(methods);
				console.log()

				// Update the selected rating method to reflect the new options
				if (this.viewModel.selected_rating_method() && this.viewModel.selected_rating_method().rating_system_id)
				{
					let updated_method = this.viewModel.rating_methods().find(method =>
						method.rating_system_id === this.viewModel.selected_rating_method().rating_system_id
					);
					// Only update if  matching method is found
					if (updated_method) 
						this.viewModel.selected_rating_method(updated_method);
					
				}

				if (this.viewModel.selected_rating_method())
				{
					if (this.viewModel.selected_rating_method().options)
					{
						let options = this.viewModel.selected_rating_method().options;
						let type = this.viewModel.selected_rating_method().rating_method_type;

						if (type === 'input' || type === 'number' || type === 'range')
						{
							if (options)
								this.viewModel.limited_options(true);
							else
								this.viewModel.limited_options(false);
						}
						else
							this.viewModel.limited_options(false);
					}
					else
						this.viewModel.limited_options(false);
				}
				else
					this.viewModel.limited_options(false);
			}
		} catch (error) {
			console.error(error);
		}

		Utils.refresh_data_visible_roles();
	}

	async update_company_objectives()
	{
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_company_objectives',
				schema: 'perfm_manage'
			});
			if (res.status == 'OK')
			{
				// Add edit properties and sort according to numbers
				let processed_records = res.records.sort((a, b) => a.objective_number - b.objective_number).map(obj => {
					obj.edit = ko.observable(false);
					obj.adding_goal = ko.observable(false);
					obj.goals = ko.observableArray(obj.goals || []);
					if (obj.goals())
					{
						obj.goals(obj.goals().sort((a, b) => a.goal_nr - b.goal_nr).map(goal => {
							goal.edit = ko.observable(false);
							goal.adding_goal = ko.observable(false);
							goal.goal_sub_number = ko.observable(parseFloat(goal.goal_nr.toString().split('.')[1]));
							goal.subgoals = ko.observableArray(goal.subgoals || [])
							if (goal.subgoals())
							goal.subgoals(goal.subgoals().sort((a, b) => {
								// Extract the last part of the subgoal number and convert it to a number for comparison
								let aLastPart = parseFloat(a.subgoal_nr.toString().split('.')[2]);
								let bLastPart = parseFloat(b.subgoal_nr.toString().split('.')[2]);
						
								return aLastPart - bLastPart;
							}).map(subgoal => {
								let parts = subgoal.subgoal_nr.toString().split('.');
								subgoal.edit = ko.observable(false);
								subgoal.subgoal_nr = ko.observable(subgoal.subgoal_nr);
								subgoal.subgoal_sub_number = ko.observable(parts.length > 2 ? parseFloat(parts[2]) : 0);
								subgoal.subgoal_prefix = ko.observable(parts.length > 1 ? parts.slice(0, 2).join('.') : subgoal.subgoal_nr);
								return subgoal;
							}));
							return goal;
						}));
					}
					return obj;
				});
				this.viewModel.company_objectives(processed_records);
			}
			else
				Grape.alerts.alert({type:'error', message: 'Error occurred while loading company objectives'});
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type:'error', message: 'Error occurred while loading company objectives'});
		}
		Utils.refresh_data_visible_roles();
	}

	async update_measures()
	{
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'measure',
				schema: 'perfm_manage'
			})

			if (res.status != 'ERROR')
				this.viewModel.measures(res.records);
		} catch (error) {
			console.error(error);
		}
		Utils.refresh_data_visible_roles();
	}

	async update_peer_group(peerGroupData) {
		try {
			let options = {
				peer_group_id: peerGroupData.peer_group_id || null,
				peer_group_name: peerGroupData.peer_group_name,
				action: peerGroupData.peer_group_id ? 'edit' : 'add'
			};
			
			let res = await Grape.fetches.postJSON('/performance_management/peer_group/save', options);
			if (res.status != 'ERROR') {
				// Refresh the peer groups data
				Grape.alerts.alert({ type: 'success', message: 'Peer group saved successfully' });
				this.updateData();
			} else {
				Grape.alerts.apiError(res);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', message: 'Error occurred while saving peer group'});
		}
		Utils.refresh_data_visible_roles();
	}
	
	async update_peer_member(memberData) 
	{
		console.log('member data', memberData);
		if (memberData === undefined) return;
		
		try {
			let options = {
				peer_group_member_id: memberData.peer_member_id || null,
				peer_group_id: memberData.peer_group_id,
				employee_id: memberData.employee_id,
				action: memberData.peer_member_id ? 'edit' : 'add'
			};

			let res = await Grape.fetches.postJSON('/performance_management/peer_member/save', options);
			console.log('res', res);

			if (res.status != 'ERROR') {
				// Save the current selected group
				const currentSelectedGroup = this.viewModel.selected_peer_group();

				// Refresh the data
				await this.get_peer_groups_and_members();

				// Restore the selected group
				if (currentSelectedGroup) {
					this.viewModel.selected_peer_group(currentSelectedGroup);
				}

				Grape.alerts.alert({ type: 'success', message: 'Peer member saved successfully' });
			} else {
				Grape.alerts.apiError(res);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', message: 'Error occurred while saving peer member'});
		}
		Utils.refresh_data_visible_roles();
	}
	
}

export default {
	route: '[/]admin/add_edit_performance_management',
	page_class: EditPerformanceManagement,
	template: template,
	template_filename: 'translation/add_edit_performance_management'
};
